import { useMemo } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type { FlatRowSelectOption } from "web_myplann/Shared/Components/FlatRow/FlatRowSelect";

export type YesNoValue = "Yes" | "No";

export const useYesNoOptions = (): FlatRowSelectOption<YesNoValue>[] => {
	const { t } = useResource();

	return useMemo(
		() => [
			{ value: "Yes", label: t(Resources.Common.yes) },
			{ value: "No", label: t(Resources.Common.no) },
		],
		[t],
	);
};
